import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { FIRST_DATE, FIRST_DAY, SECOND_DATE, SECOND_DAY } from './Constants';
import { API_URL, BACK_URL } from './URLConstants';
import { BrowserRouter, Routes, Route, Link, HashRouter } from 'react-router-dom';
import { AgendaFilePath, getParsedDate, token, scrollToTop } from './Api';

export default function Schedulepage(props) {

    const styles = {
        backgroundColor: props.color,
        // fontSize: props.fontSize,
        // fontWeight: props.bold ? 'bold' : 'normal'
    };

    const [scheduleone, setscheduleone] = useState([])  //Day1 Hall1
    const [scheduletwo, setscheduletwo] = useState([])  //Day1 Hall2
    const [schedulefour, setschedulefour] = useState([]) //Day2 Hall 1
    const [schedulefive, setschedulefive] = useState([]) //Day2 Hall 2


    useEffect(() => {
        fetchData()
        scrollToTop()
    }, [])

    const fetchData = async () => {
        const [response1, response2, response4, response5] = await Promise.all([
            axios.get(`${API_URL}/schedule/1/1`, { headers: { Authorization: `Bearer ${token}` } }),
            axios.get(`${API_URL}/schedule/1/2`, { headers: { Authorization: `Bearer ${token}` } }),
            axios.get(`${API_URL}/schedule/2/1`, { headers: { Authorization: `Bearer ${token}` } }),
            axios.get(`${API_URL}/schedule/2/2`, { headers: { Authorization: `Bearer ${token}` } }),
        ]);

        setscheduleone(response1.data);
        setscheduletwo(response2.data);
        setschedulefour(response4.data);
        setschedulefive(response5.data);

    }




    return (
        <>


            <section id="schedule" className="tg-sectionspace tg-haslayout" style={styles}>

                <div className="container">
                    <div className="row">
                        <div className="tg-eventconfrences">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="tg-headholder">
                                    <div className="tg-sectionhead tg-textalignleft">
                                        <div className="tg-sectionheading">
                                            {/* <span>Don’t forget to attend</span> */}
                                            <h2>Schedule</h2>
                                        </div>
                                        <div className="tg-description">
                                            <p>ICDRI 2023 will bring to fore demonstrated practices and solutions, delving into systems, practices, and finances, that enable provisioning of resilient infrastructure to people and economies across different geographies, climate typologies and infrastructure sectors. </p>
                                        </div>
                                        <a className="tg-btndownload" target="_blank" href={BACK_URL + AgendaFilePath}><i
                                            className="icon-calendar-full"></i><span>Download Schedule</span></a>
                                    </div>
                                </div>
                                <div className="tg-eventscheduletabs">
                                    <ul className="tg-eventschedulenav" role="tablist">
                                        <li role="presentation" className="active"><a href="#day-one"
                                            aria-controls="day-one" role="tab" data-toggle="tab">Day 01<span>{FIRST_DAY}</span></a></li>
                                        <li role="presentation"><a href="#day-two" aria-controls="day-two" role="tab"
                                            data-toggle="tab">Day 02<span>{SECOND_DAY}</span></a></li>
                                        {/* <li role="presentation"><a href="#day-three" aria-controls="day-three"
                                                role="tab" data-toggle="tab">Day 03<span>June 29, 2017</span></a></li>
                                            <li role="presentation"><a href="#day-four" aria-controls="day-four" role="tab"
                                                data-toggle="tab">Day 04<span>June 30, 2017</span></a></li> */}
                                    </ul>
                                    <div className="tg-eventschedulecontent tab-content">
                                        <div role="tabpanel" className="tab-pane active" id="day-one">
                                            <div className="tg-eventschaduletime">
                                                <h2>Day 01 Schedule</h2>
                                                <h3>{FIRST_DAY}</h3>
                                            </div>
                                            <div className="tg-eventvenuetabs">
                                                <ul className="tg-eventvenuenav" role="tablist">
                                                    <li role="presentation" className="active"><a href="#hall-one"
                                                        aria-controls="hall-one" role="tab" data-toggle="tab">Studio 1</a></li>
                                                    <li role="presentation"><a href="#hall-two" aria-controls="hall-two"
                                                        role="tab" data-toggle="tab">Studio 2</a></li>
                                                    {/* <li role="presentation"><a href="#hall-three"
                                                            aria-controls="hall-three" role="tab"
                                                            data-toggle="tab">Crystal hall</a></li>
                                                        <li role="presentation"><a href="#hall-four"
                                                            aria-controls="hall-four" role="tab"
                                                            data-toggle="tab">Mystry hall</a></li>
                                                        <li role="presentation"><a href="#hall-five"
                                                            aria-controls="hall-four" role="tab"
                                                            data-toggle="tab">Splash hall</a></li> */}
                                                </ul>
                                                <div className="tg-eventvenuecontent tab-content">
                                                    <figure className="tg-hallimg">
                                                        {/* <img src="images/hall-bg.jpg" alt="" /> */}
                                                    </figure>
                                                    <div role="tabpanel" className="tab-pane active" id="hall-one">

                                                        {scheduleone.map(hallonedayone => (
                                                            <div key={hallonedayone.id} className="tg-event">
                                                                <div className="tg-eventhead">
                                                                    <div className="tg-leftarea">


                                                                        {/* <h2> */}
                                                                        <div className="tg-title">

                                                                            {hallonedayone.description === ''
                                                                                ? <h2>{getParsedDate(hallonedayone.startdate)} - {getParsedDate(hallonedayone.enddate)}: {hallonedayone.title}</h2>
                                                                                : <h2><Link target="_blank" to={`/page/${hallonedayone.id}`}>{getParsedDate(hallonedayone.startdate)} - {getParsedDate(hallonedayone.enddate)}: {hallonedayone.title}</Link></h2>
                                                                            }
                                                                        </div>



                                                                    </div>
                                                                    <div className="tg-rightarea">

                                                                        {/* <Link  target="_blank" to={`/page/${hallonedayone.id}`}>
                                                                            <i
                                                                                className="fa fa-mail-forward"></i></Link> */}

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        ))}

                                                    </div>
                                                    <div role="tabpanel" className="tab-pane" id="hall-two">
                                                        {scheduletwo.map(halltwodayone => (
                                                            <div key={halltwodayone.id} className="tg-event">
                                                                <div className="tg-eventhead">
                                                                    <div className="tg-leftarea">

                                                                        <div className="tg-title">

                                                                            {halltwodayone.description === ''
                                                                                ? <h2>{getParsedDate(halltwodayone.startdate)} - {getParsedDate(halltwodayone.enddate)}: {halltwodayone.title}</h2>
                                                                                : <h2><Link target="_blank" to={`/page/${halltwodayone.id}`}>{getParsedDate(halltwodayone.startdate)} - {getParsedDate(halltwodayone.enddate)}: {halltwodayone.title}</Link></h2>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="tg-rightarea">
                                                                        {/* <Link  target="_blank" to={`/page/${halltwodayone.id}`}>
                                                                            <i
                                                                                className="fa fa-mail-forward"></i></Link> */}
                                                                        {/* <a className="tg-btnfarword" href="#"><i
                                                                            className="fa fa-mail-forward"></i></a> */}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div role="tabpanel" className="tab-pane" id="day-two">
                                            <div className="tg-eventschaduletime">
                                                <h2>Day 02 Schedule</h2>
                                                <h3>{SECOND_DAY}</h3>
                                            </div>
                                            <div className="tg-eventvenuetabs">
                                                <ul className="tg-eventvenuenav" role="tablist">
                                                    <li role="presentation" className="active"><a href="#hall-six"
                                                        aria-controls="hall-six" role="tab" data-toggle="tab">Studio 1</a></li>
                                                    <li role="presentation"><a href="#hall-seven"
                                                        aria-controls="hall-seven" role="tab"
                                                        data-toggle="tab">Studio 2</a></li>

                                                </ul>
                                                <div className="tg-eventvenuecontent tab-content">
                                                    <figure className="tg-hallimg">
                                                        {/* <img src="images/hall-bg.jpg" alt="" /> */}
                                                    </figure>
                                                    <div role="tabpanel" className="tab-pane active" id="hall-six">
                                                        {schedulefour.map(hallonedaytwo => (
                                                            <div key={hallonedaytwo.id} className="tg-event">
                                                                <div className="tg-eventhead">
                                                                    <div className="tg-leftarea">
                                                                        {/* <time datetime="2017-12-12">{getParsedDate(hallonedaytwo.startdate)} - {getParsedDate(hallonedaytwo.enddate)}</time> */}
                                                                        <div className="tg-title">

                                                                            {hallonedaytwo.description === ''
                                                                                ? <h2>{getParsedDate(hallonedaytwo.startdate)} - {getParsedDate(hallonedaytwo.enddate)}: {hallonedaytwo.title}</h2>
                                                                                : <h2><Link target="_blank" to={`/page/${hallonedaytwo.id}`}>{getParsedDate(hallonedaytwo.startdate)} - {getParsedDate(hallonedaytwo.enddate)}: {hallonedaytwo.title}</Link></h2>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="tg-rightarea">
                                                                        {/* <Link  target="_blank" to={`/page/${hallonedaytwo.id}`}>
                                                                            <i
                                                                                className="fa fa-mail-forward"></i></Link> */}
                                                                        {/* <a className="tg-btnfarword" href="#"><i
                                                                            className="fa fa-mail-forward"></i></a> */}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div role="tabpanel" className="tab-pane" id="hall-seven">
                                                        {schedulefive.map(halltwodaytwo => (
                                                            <div key={halltwodaytwo.id} className="tg-event">
                                                                <div className="tg-eventhead">
                                                                    <div className="tg-leftarea">

                                                                        <div className="tg-title">
                                                                            {halltwodaytwo.description === ''
                                                                                ? <h2>{getParsedDate(halltwodaytwo.startdate)} - {getParsedDate(halltwodaytwo.enddate)}: {halltwodaytwo.title}</h2>
                                                                                : <h2><Link target="_blank" to={`/page/${halltwodaytwo.id}`}>{getParsedDate(halltwodaytwo.startdate)} - {getParsedDate(halltwodaytwo.enddate)}: {halltwodaytwo.title}</Link></h2>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="tg-rightarea">

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        ))}

                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

        </>
    )
}
